module.exports = __webpack_public_path__ + "media/site/images/key-features/screenshots/desktop-painless-time-tracking-ce60b6574f0289094a47dba68a3c6a21.png";